import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum ModalsName {
  ADD,
  PROJECTS,
  TEXTURES
}

// Define a type for the slice state
interface ModalsState {
  [ModalsName.ADD]: {
      isOpen: boolean,
      level: number
      category:string
  },
  [ModalsName.PROJECTS]: {
    isOpen: boolean,
  },
  [ModalsName.TEXTURES]: {
    isOpen: boolean;
    key: string;
  }
}

// Define the initial state using that type
const initialState: ModalsState = {
  [ModalsName.ADD]: {
      isOpen: false,
      level: 1,
      category: ''
  },
  [ModalsName.PROJECTS]: {
    isOpen: false
  },
  [ModalsName.TEXTURES]: {
    isOpen: false,
    key: ''
  }
};

export const ModalsSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    setModalOpen(state, action: PayloadAction<{ key: ModalsName, value: boolean}>) {
        if(action.payload.value === false) {
          state[ModalsName.ADD].category = '';
          state[ModalsName.ADD].level = 1;
        }
        if(action.payload.key === ModalsName.TEXTURES && action.payload.value === false) state[ModalsName.TEXTURES].key = '';
        state[action.payload.key].isOpen = action.payload.value;
    },
    setLevel: (state, action: PayloadAction<number>) => {
      if(action.payload === 3) state[ModalsName.ADD].level = 3;
      if(action.payload === 1) state[ModalsName.ADD].category = '';
      state[ModalsName.ADD].level = action.payload;
    },
    setCategory: (state, action: PayloadAction<string>) => {
      if(action.payload === '') state[ModalsName.ADD].level = 1;
      else state[ModalsName.ADD].level = 2;
      state[ModalsName.ADD].category = action.payload;
    },
    setTextureKey: (state, action: PayloadAction<string>) => {
      state[ModalsName.TEXTURES].key = action.payload;
    }
  },
});

export const {
    setModalOpen,
    setLevel,
    setCategory,
    setTextureKey
} = ModalsSlice.actions;

export default ModalsSlice.reducer;